import { extractBlogMdxSource } from "@/utils/blogMdxSource";

/** Removes blog markdown markers, keeping readable plain text for slugs and TOC labels. */
export function stripBlogMarkdown(source: string): string {
  let text = source;
  text = text.replace(/\(\(([\s\S]+?)\)\)/g, "$1");
  text = text.replace(/\*\*([^*]+)\*\*/g, "$1");
  text = text.replace(/\*([^*\n]+)\*/g, "$1");
  text = text.replace(/_([^_\n]+)_/g, "$1");
  text = text.replace(/`([^`\n]+)`/g, "$1");
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
  return text.trim();
}

export function plainBlogHeadingLabel(source: unknown): string {
  return stripBlogMarkdown(extractBlogMdxSource(source));
}

export function slugifyBlogHeadingText(source: unknown): string {
  return plainBlogHeadingLabel(source)
    .toLowerCase()
    .normalize("NFD")
    .replaceAll(/\p{M}/gu, "")
    .replaceAll(/[^a-z0-9]+/g, "-")
    .replaceAll(/(^-|-$)/g, "");
}
